<template>
  <div class="home-content">
    <div class="head-select">
      <el-input
        v-model="searchval"
        placeholder="请输入设备ID"
        class="search-input"
      ></el-input>
      <el-select
        v-model="selectval"
        placeholder="设备状态"
        class="search-select"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button type="primary" class="search-button" @click="search">
        <img src="@/assets/icon/search.png" alt="" class="button-icon" />
        查询
      </el-button>
    </div>
    <div class="home-list-con">
      <div class="list-con">
        <el-table
          ref="filterTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            :prop="item.key"
            :label="item.label"
            :width="item.width"
            v-for="item in dataSource"
            :key="item.key"
          >
            <template slot-scope="scope">
              <div class="text" v-if="item.key !== 'status' && item.key !== 'scheme'">
                {{ scope.row[item.key] }}
              </div>
              <div class="text" v-if="item.key == 'scheme'">
                {{ scope.row[item.key].name }}
              </div>
              <div
                v-if="item.key == 'status'"
                class="statu"
                :class="{ false: scope.row[item.key] == 'status' }"
              >
                <div class="small-point"></div>
                {{ scope.row.status != 0 ? "已在线" : "已离线" }}
              </div>
              <div v-else-if="item.key == 'menu'" class="tab-menu">
                <div class="edit" @click="editfn(scope.row)">编辑</div>
                <div class="line"></div>
                <div class="menudata" @click="menudata">换针数据</div>
                <div class="line"></div>
                <div
                  class="menubutton"
                  :class="{ close: scope.row['status'] } == 0"
                  @click="closefn(0, scope.row)"
                  v-if="scope.row['status'] == 0"
                >
                  开启机器
                </div>
                <div
                  class="menubutton"
                  :class="{ close: scope.row['status'] } !== 0"
                  v-else
                  @click="closefn(1, scope.row)"
                >
                  关闭机器
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalData"
        style="margin-top: 30px; float: right; margin-right: 60px"
        :current-page="current_page"
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange_prev"
        @next-click="handleCurrentChange_next"
      >
      </el-pagination>
    </div>

    <el-dialog
      :visible.sync="editvisible"
      :modal-append-to-body="true"
      custom-class="edit-dialog"
      @close="dialogclose"
      :destroy-on-close="true" 
      :close-on-click-modal ="false"
      width="720px"
    >
      <div slot="title">设备详情</div>
      <div class="edit-content" :key="nowtime">
        <div class="edit-item" v-for="item in dialogmap" :key="item.value">
          <div class="text">{{ item.name }}</div>
          <el-input
            class="edit-input"
            v-model="dialogData[item.value]"
            placeholder=""
            :disabled="item.disabled"
          ></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="button-group">
          <el-button type="info" size="small" @click="dialogclose"
            >取消</el-button
          >
          <el-button type="primary" size="small" @click="setDetail"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  login,
  getDeviceList,
  getDeviceDetail,
  setDeviceDetail,
  deviceCommand,
} from "../../api/index.js";
export default {
  components: {},
  data() {
    return {
      searchval: "",
      selectval: "",
      options: [
        { label: "已在线", value: "online" },
        { label: "已离线", value: "offline" },
      ],
      dataSource: [
        { label: "设备编号", key: "sn", width: "170" },
        { label: "设备imei", key: "imei", width: "170" },
        { label: "设备激活日期", key: "create_time", width: "200" },
        { label: "设备状态", key: "status", width: "150" },
        { label: "设备位置", key: "address", width: "150" },
        { label: "设备方案", key: "scheme", width: "200" },
        { label: "最后在线时间", key: "last_online_time", width: "200" },
        { label: "操作", key: "menu", width: "300" },
      ],
      tableData: [],
      multipleSelection: [],
      slotmap: ["statu", "menu"],
      editvisible: false,
      selectrow: {},
      dialogmap: [
        { name: "设备编号", value: "sn", disabled: true },
        { name: "设备激活日期", value: "create_time", disabled: true },
        { name: "设备位置", value: "address" },
        { name: "管理员", value: "manager" },
        { name: "最后在线时间", value: "last_online_time", disabled: true },
      ],
      nowtime: "",
      dialogData: {},
      totalData: 0,
      current_page: 1,
    };
  },
  computed: {},
  async created() {},
  mounted() {
    this.getData();
  },
  watch: {},
  methods: {
    formatDate(value) {// 时间戳转换日期格式方法
        if (value == null) {
            return '';
        } else {
            value=value*1000
            let date = new Date(value);
            let y = date.getFullYear();// 年
            let MM = date.getMonth() + 1;// 月
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();// 日
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();// 时
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();// 分
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();// 秒
            s = s < 10 ? ('0' + s) : s;
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        }
    },    
    handleCurrentChange_next() {
      this.current_page += 1;
    },
    handleCurrentChange_prev() {
      this.current_page -= 1;
    },
    handleCurrentChange() {
      this.getData();
    },
    // 更新换阵设备（编辑）详情数据
    async setDetail() {
      let params = {
        id: this.dialogData.id,
        address: this.dialogData.address,
        //uids: this.dialogData.uids,
        //password: this.dialogData.password,
      };
      await setDeviceDetail(params)
        .then((res) => {
          if (res.code == 1) {
            this.editvisible = false;
            this.getData();
          } else {
            this.$message.error(res.msg);
            //this.$message.error("修改数据失败");
          }

          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取数据
    getData() {
      let params = {
        limit: 10,
        page: this.current_page,
        "search[0][field]":"sn",
        "search[0][val]":this.searchval,
        "search[0][operator]":'LIKE',                
      };
      if(this.selectval){
        var val=this.selectval=="online"?1:0;
        params = {
          limit: 10,
          page: this.current_page,
          "search[0][field]":"sn",
          "search[0][val]":this.searchval,
          "search[0][operator]":'LIKE', 
          "search[1][field]":"status",
          "search[1][val]":val,
          "search[1][operator]":'eq',                
        };
      }
      getDeviceList(params)
        .then((res) => {
          if (res.code == 1) {
            this.tableData = res.data.list;
            for(var i=0;i<this.tableData.length;i++){
              this.tableData[i].create_time=this.formatDate(this.tableData[i].create_time);
            }
            console.log("list_data==="+JSON.stringify(this.tableData));
            this.totalData = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search() {
      this.current_page=1;
      this.getData();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 打开编辑获取数据详情
    async editfn(item) {
      let params = {
        id: item.id,
      };
      await getDeviceDetail(params)
        .then((res) => {
          if (res.code == 1) {
            this.dialogData = res.data.row;
            console.log(this.dialogData);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.selectrow = item;
      this.nowtime = new Date().getTime();
      this.editvisible = true;
    },
    menudata() {
      this.$router.push("change")
    },
    closefn(status, item) {
      let data = {
        id: item.id,
        status: "",
      };
      if (status == 0) {
        data.status = 1;
      } else if (status == 1) {
        data.status = 0;
      }
      deviceCommand(data)
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getData();
          } else {
            this.$message.error(res.msg);
            //this.$message.error("操作失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dialogclose() {
      this.editvisible = false;
    },
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.home-content {
  height: calc(100% - 64px);
  .head-select {
    padding: 24px 0 24px 42px;
    display: flex;
    align-items: center;
  }
  .search-input {
    width: 245px;
  }
  .search-select {
    width: 185px;
    margin-left: 16px;
  }
  .search-button {
    margin-left: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #fefeff;
    line-height: 14px;
    padding: 10px 20px;
    .button-icon {
      margin-right: 10px;
      width: 15.5px;
      height: 15.5px;
    }
  }
  .home-list-con {
    background: #fff;
    height: calc(100% - 88px);
  }
  .list-con {
    padding-top: 30px;
    margin: 0 26px 0;
    .el-table__header-wrapper {
      background: #fafafa;
    }
  }
  .statu {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #507af9;
    &.false {
      color: #8e8e8e;
      .small-point {
        background: #8e8e8e;
      }
    }
    .small-point {
      display: inline-flex;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #507af9;
      margin-right: 12px;
    }
  }
  .tab-menu {
    display: flex;
    align-items: center;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 14px;
    color: #507af9;
    column-gap: 13px;
    .line {
      width: 1px;
      height: 12px;
      background: #e6e6e6;
    }
    .edit,
    .menudata {
      cursor: pointer;
    }
    .menubutton {
      cursor: pointer;
      color: #fff;
      padding: 8px 15px;
      background: #507af9;
      border-radius: 5px;
    }
  }
}
</style>
<style lang="scss">
.list-con {
  .el-table__header-wrapper {
    th {
      background: #fafafa;
      color: #0c0c0c;
    }
  }
}
.edit-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #e6e6e6;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #23262c;
  }
  .edit-content {
    margin: 37px 75px;
  }
  .el-dialog__body {
    padding: 0;
    .edit-input {
      margin: 10px 0 32px;
    }
  }
  .edit-item {
    .test {
      margin-left: 8px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 16px;
      color: #2c2e33;
    }
  }
  .el-dialog__footer {
    border-top: 1px solid #e6e6e6;
    .button-group {
      display: flex;
      margin-left: auto;
      width: fit-content;
      align-items: center;
      .el-button {
        margin-right: 20px;
      }
    }
  }
}
</style>